import { Close16, Close20 } from "@carbon/icons-react";
import { StandardTable, Button, Pagination, Modal } from "react3l-ui-library";
import { usePermissionHistoryListHook } from "./PermissionHistoryListHook";
import { MODAL_SIZE } from "react3l-ui-library/build/components/Modal/Modal";
import { Spin } from "antd";

function PermissionHistoryList() {
    const {
        translate,
        handleGoBack,
        handlePagination,
        requestHistoryList,
        requestHistoryCount,
        rowSelection,
        columns,
        filter,
        dataHistoryPreview,
        columnsModalHistoryPreview,
        isVisible,
        handleCloseModal,
        isSpinning,
    } = usePermissionHistoryListHook();

    return (
        <Spin spinning={isSpinning}>
            <div className="page-content page-content-dxg" id={"page-content-dxg-id"}>
                <div className="info-component ml-4 mb-3">
                    <span>{translate("general.defaultHeader.account")}</span>
                    <span> &gt; </span>
                    <span>{translate("menu.title.folderPermissionGroup")}</span>
                    <span> &gt; </span>
                    <span className="info-primary">
                        {translate("general.actions.listHistory")}
                    </span>
                </div>
                <div className="page page-history mt-0">
                    <div className="pt-3 pb-1 ml-3 d-flex justify-content-between">
                        <h5 className="font-bold page-title">{translate("general.actions.listHistory")}</h5>
                        <div>
                            <Button
                                type="secondary"
                                className="btn--lg btn-red mr-3"
                                icon={<Close16 />}
                                onClick={handleGoBack}
                            >
                                {translate("general.actions.close")}
                            </Button>
                        </div>
                    </div>
                    <div className="page-history__list">
                        <StandardTable
                            rowKey={"versionId"}
                            columns={columns}
                            dataSource={requestHistoryList}
                            tableSize={"md"}
                            rowSelection={rowSelection}
                            bordered
                        />
                        <Pagination
                            skip={filter?.skip}
                            take={filter?.take}
                            total={requestHistoryCount}
                            onChange={handlePagination}
                        />
                    </div>
                </div>

                <Modal
                    size={MODAL_SIZE.SIZE_1200}
                    visible={isVisible === true ? true : false}
                    visibleFooter={true}
                    title={translate("general.history.preview")}
                    handleCancel={handleCloseModal}
                    closable={false}
                    titleButtonCancel={translate("general.actions.close")}
                    titleButtonApply={translate("general.actions.save")}
                    wrapClassName={"dxg-modal-wrap-one-btn"}
                    className="m-t--sm"
                >
                    <StandardTable
                        rowKey={"__rowKey"}
                        columns={columnsModalHistoryPreview}
                        dataSource={dataHistoryPreview}
                        tableSize={"md"}
                        bordered={false}
                    />
                    <span className={"close-modal"} onClick={handleCloseModal}>
                        <Close20 />
                    </span>
                </Modal>
            </div>
        </Spin>
    );
}

export default PermissionHistoryList
